export default __webpack_public_path__ + "static/media/Shein.79ac1a69.png";